import { convertISTToTimezone } from "./timezone";
export const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
    });
};
export const formatTime = (timeStr, dateStr, timezone) => {
    let time = timeStr;
    if (timeStr.includes("T")) {
        const date = new Date(timeStr);
        time = `${date.getHours().toString().padStart(2, "0")}:${date.getMinutes().toString().padStart(2, "0")}`;
    }
    return convertISTToTimezone(time, dateStr, timezone);
};
export const calculateDuration = (duration, fromTime, toTime) => {
    if (duration)
        return duration;
    if (fromTime && toTime) {
        const parseTime = (t) => {
            const [h, m] = t.split(":").map(Number);
            return h * 60 + m;
        };
        const from = parseTime(fromTime);
        const to = parseTime(toTime);
        return to - from;
    }
    return 60;
};
export const getPatientDisplayName = (appointmentPatientName, patient) => {
    return (appointmentPatientName ||
        patient?.patientName ||
        [patient?.firstName, patient?.middleName, patient?.lastName]
            .filter(Boolean)
            .join(" ") ||
        "Patient");
};
